/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FluentValidation_Severity {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
}
